import React from 'react';
import SurveyAuthGate from './survey/SurveyAuthGate.tsx';
import SurveyResponsesViewer from './SurveyResponsesViewer.tsx';
import './SurveyResultsPage.css';

/**
 * Allowlist of email addresses permitted to view survey results.
 * Mirrors the backend's `SURVEY_RESULTS_ALLOWLIST` (and falls back to
 * the same defaults) — kept in sync manually. Frontend enforcement is
 * for UX only; the backend's `requireSurveyResultsAccess` middleware
 * is the actual security boundary.
 */
const SURVEY_RESULTS_ALLOWLIST = [
  'mlarrow@sweetspotfarms.com',
  'tlew@sweetspotfarms.com',
  'benny@sweetspotfarms.com',
];

const SurveyResultsPage: React.FC = () => (
  <SurveyAuthGate
    allowedEmails={SURVEY_RESULTS_ALLOWLIST}
    pageTitle="Sweetspot — Survey Results"
    signInBadge="Restricted Access"
    signInTitle="Sign in to view survey results"
    signInDescription={
      <>
        Access to the employee engagement survey results is limited to a small group of people at Sweetspot.
        Sign in with your <strong>@sweetspotfarms.com</strong> Google account to continue.
      </>
    }
    anonNote={null}
    notAllowedMessage="Your account is not authorized to view survey results. If you think that's a mistake, ask HR to add you to the allowlist."
  >
    {(signOutHandler, user) => (
      <div className="survey-results-page">
        <div className="survey-results-page__topbar">
          <div className="survey-results-page__brand">Employee Engagement Survey — Results</div>
          <div className="survey-results-page__account">
            <span className="survey-results-page__email">{user.email}</span>
            <button
              type="button"
              className="survey-results-page__signout"
              onClick={signOutHandler}
            >
              Sign out
            </button>
          </div>
        </div>
        <SurveyResponsesViewer />
      </div>
    )}
  </SurveyAuthGate>
);

export default SurveyResultsPage;
